import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { createContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
export var ProvidersContext = /*#__PURE__*/createContext(null);
export var InlineCommentsStateContext = /*#__PURE__*/createContext({});

/**
 * @private
 * @deprecated The FG platform_renderer_annotation_draft_position_fix will make this context redundant as the draft position
 * has been moved to the AnnotationRangeProvider in order to be more consistent with the hover and selection ranges.
 * Once the FG is rolled out this context will be removed. Please ensure any changes are duplicated to the AnnotationRangeProvider.
 */
export var AnnotationsDraftContext = /*#__PURE__*/createContext(null);

/**
 * @private
 * @deprecated The FG platform_renderer_annotation_draft_position_fix will make this context redundant as the draft position
 * has been moved to the AnnotationRangeProvider in order to be more consistent with the hover and selection ranges.
 * Once the FG is rolled out this context will be removed. Please ensure any changes are duplicated to the AnnotationRangeProvider.
 */
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
export var AnnotationsDraftContextWrapper = /*#__PURE__*/function (_React$Component) {
  function AnnotationsDraftContextWrapper() {
    var _this;
    _classCallCheck(this, AnnotationsDraftContextWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AnnotationsDraftContextWrapper, [].concat(args));
    _defineProperty(_this, "state", {
      position: null
    });
    _defineProperty(_this, "applyAnnotationDraftAt", function (nextPosition) {
      var setDraftRange = _this.props.setDraftRange;

      // Set the draft range to preserve it downstream
      setDraftRange();

      // We need to support a new draft being made while one exists and overwrite it
      // Set the document position for the newly created draft
      _this.setState({
        position: nextPosition
      });
    });
    _defineProperty(_this, "clearAnnotationDraft", function () {
      var clearDraftRange = _this.props.clearDraftRange;

      // Clear the draft range
      clearDraftRange();

      // Clear the draft position in the document
      _this.setState({
        position: null
      });
    });
    return _this;
  }
  _inherits(AnnotationsDraftContextWrapper, _React$Component);
  return _createClass(AnnotationsDraftContextWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isNestedRender = _this$props.isNestedRender;
      var position = this.state.position;
      var applyAnnotationDraftAt = this.applyAnnotationDraftAt;
      var clearAnnotationDraft = this.clearAnnotationDraft;

      /*
       * If this is a nested render, we do not provide the draft context
       * because it has already been provided higher up the component tree
       * and we need the original context to create draft annotations on extensions.
       */
      return isNestedRender && fg('confluence_frontend_fix_extension_draft_annotation') ? /*#__PURE__*/React.createElement("span", {
        "data-testid": "context-wrapper-without-provider"
      }, children({
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        clearAnnotationDraft: clearAnnotationDraft
      })) : /*#__PURE__*/React.createElement(AnnotationsDraftContext.Provider, {
        value: position
      }, children({
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        clearAnnotationDraft: clearAnnotationDraft
      }));
    }
  }]);
}(React.Component);